<template>
  <div>
    <h2>日用气记录</h2>
    <Spin fix v-show="isSpinShow">
      <Icon type="ios-loading" size="18" class="spin-icon-load"></Icon>
      <div>Loading</div>
    </Spin>
    <Scroll :height="height * 0.9" :on-reach-bottom="handleReachEdge" :distance-to-edge="[100,1]">
      <Collapse class="collapse" accordion>
        <Panel v-for="(valueitem, index) in records" class="panel" :name="valueitem.title + index">
          {{valueitem.title}}
          <template slot="content">
            <Table
              v-for="(columoitem, index) in dailyCustomerRecordColumns[valueitem.index]"
              border
              v-if="valueitem['value'][0][columoitem[0]['children'][2]['key']] != 0"
              :columns="columoitem"
              :data="valueitem.value"
            ></Table>
            <label v-if="valueitem.value[0].date0 == ''" style="margin-left: 20px;">当前数据未上传用气记录</label>
          </template>
        </Panel>
      </Collapse>
      <p>上滑加载</p>
    </Scroll>
  </div>
</template>
<script>
import { constants } from "crypto";
export default {
  mounted() {},
  data() {
    return {
      meterId: "",
      height: document.body.clientHeight,
      width: document.body.clientWidth,
      dailyRecord: [],
      dailyRecordColumns: [],
      dailyCustomerRecordColumns: [],
      records: [],
      formatObject: {},
      pageSize: 40,
      pageNo: 1,
      isSpinShow: false
    };
  },
  methods: {
    clearData() {
      this.dailyRecord = [];
      this.dailyRecordColumns = [];
      this.records = [];
      this.formatObject = {};
      this.pageNo = 1;
    },
    getDailyRecord() {
      var that = this;
      that.isSpinShow = true;
      $.ajax({
        url:
          "/api/instructions/searchUpInstructions?page=" +
          that.pageNo +
          "&pageAmount=" +
          that.pageSize,
        contentType: "application/json",
        type: "post",
        data: JSON.stringify({
          commandDeviceId: that.meterId,
          commandType: "0x86",
          page: that.pageNo,
          pageAmount: that.pageSize
        }),
        dataType: "json",
        success: function(receiveData) {
          if (receiveData.body == null) {
            return;
          }
          var columns = receiveData.body.columns;
          var dataList = receiveData.body.resultList;

          if (columns.length == 0 || dataList == 0) {
            return;
          }

          // 拼接表头
          columns.forEach(function(value, i) {
            if (i != 0) {
              let tempArray = [];
              value.children.forEach(function(value, i) {
                value["width"] = that.width / 4.2;
              });
              tempArray.push(value);
              let children = value.children;
              children.forEach(function(value, i) {
                let key = value.key;
                if (
                  value[key] != null &&
                  value[key] != undefined &&
                  value[key].format != null &&
                  value[key].format != undefined
                ) {
                  that.formatObject[key] = value[key].format;
                }
              });
              that.dailyRecordColumns.push(tempArray);
            }
          });

          dataList.forEach(function(value, i) {
            let temp = {};
            let tempArray = [];
            let count = 0;
            Object.keys(value).forEach(function(valueo, i) {
              if (that.formatObject[valueo] != undefined) {
                if (count % 2 == 1) {
                  value["date" + parseInt(count/2)] = global.dateFtt(
                    "yyyy-MM-dd",
                    new Date(value[valueo].replace(/\-/g, "/"))
                  );
                }
                value[valueo] = global.dateFtt(
                  that.formatObject[valueo],
                  new Date(value[valueo].replace(/\-/g, "/"))
                );
                count++;
              }
            });
            tempArray.push(value);
            temp["title"] = global.dateFtt(
              "数据接收日期：yyyy-MM-dd",
              new Date(value.commandTimestamp.replace(/\-/g, "/"))
            );
            temp["value"] = tempArray;
            temp["index"] = i;
            that.records.push(temp);

            // 根据用气日期定制生成columns
            var tempColumns = JSON.parse(JSON.stringify(that.dailyRecordColumns));
            tempColumns.forEach(function(columnsObject, index) {
              if(temp.value != undefined && temp.value.length > 0){
                  let cuttentDate = temp.value[0]["date" + index];
                  let title = "开火日期:" + cuttentDate;
                  columnsObject[0].key = title;
                  columnsObject[0].title = title;
              }
            });

            that.dailyCustomerRecordColumns.push(tempColumns);
          });

          console.log(that.records);
        },
        error: function(textStatus) {
          that.$Notice.error({
            title: "异常",
            desc: "接口请求异常"
          });
        },
        complete: function(XMLHttpRequest, textStatus) {
          that.isSpinShow = false;
        }
      });
    },
    handleReachEdge(dir) {
      return new Promise(resolve => {
        if (dir > 0) {
        } else {
          this.pageNo = this.pageNo + 1;
          this.getDailyRecord();
        }
        resolve();
      });
    }
  }
};
</script>
<style scope>
.collapse {
  margin: 5px;
  background-color: white;
  text-align: left;
  font-size: 16px;
}

.panel {
  font-weight: 800;
  font-family: "SimSun";
  font-size: 16px;
}
.row {
  margin: 5px;
}
.ivu-collapse-content {
  padding: 0;
}
</style>

